const { screens } = require("tailwindcss/defaultTheme")

module.exports = {
  ...screens,
  xs: "375px",
  "2xl": "1466px",
}
